import { Container, Row, Col } from "react-bootstrap";
import Right from "../../utils/form-aside/Right";
import Left from "../../utils/form-aside/Left";





export default function Survey() {

  return (
    <Container
      style={{
        margin: "0",
        padding: "0",
        minWidth: "100%",
      }}
    >
      <Row
        style={{
          padding: "0",
          minHeight: "100vh",
          width: "100%",
          margin: "auto",
        }}
      >
        <Col
          xs={{ span: 6, order: 2 }}
          md={{ span: 6, order: 1 }}
          lg={{ span: 6, order: 1 }}
          style={{
            padding: "0",
          }}
          className="d-none d-lg-block"
        >
          <Left />
        </Col>

        <Col
          xs={{ span: 12, order: 1 }}
          md={{ span: 12, order: 2 }}
          lg={{ span: 6, order: 2 }}
          style={{}}
        >
          <Right
          />
        </Col>
      </Row>
    </Container>
  );
}
